import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'translationPipe',
  // standalone: true
})
export class TranslationPipe implements PipeTransform {

  async transform(key: string, args?: any): Promise<string>  {
    console.log('called');
    let lang = localStorage.getItem('lang') || 'en';
    let langData = localStorage.getItem('langData') as any;
    // let jsonData = lang == 'en' ? jsonDataEnglish : jsonDataGerman; 
    let obj:any;


    if(!langData || JSON.parse(langData).name != lang) {
      let jsonData = await import(`./../../../../../assets/i18n/home/${lang}.json`);
      console.log(jsonData);

      obj = {name: lang, data: (jsonData as any)} ;
      localStorage.setItem('langData', JSON.stringify(obj));
    }
    // store / set jsonData in localstorage
    else {  
      obj = JSON.parse(langData);
    }
    console.log(obj['data'][key]);
    
    return obj['data'][key] || 'Key not found';
  }

}
